import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
import { WalletAccount } from '@exodus/models';
const DEFAULT_WALLET_ACCOUNT = WalletAccount.DEFAULT_NAME;
const resultFunction = (active, enabled) => active && enabled.includes(active) ? active : DEFAULT_WALLET_ACCOUNT;
export default defineSelectorResultFunction({
    id: 'active',
    resultFunction,
    dependencies: [
        { selector: 'configuredActiveWalletAccount' },
        { selector: 'enabled' },
    ],
});
